import WeexThemeView from './packages/weex-theme-view';
export {
  WeexThemeView
}

// weexTheme class
let WEEX_THEME_CHANNEL = null
let UseResponseState = true // 是否引用其他页面的 state

let weexTheme = null
let waitCreateWeexThemeSetThemeArgumentList = []

class WeexTheme {
  constructor(options) {
    if (!options) options = {}
    let { id, themes, tag, default: defaultTheme, root: defaultRoot } = options
    let supportRoot = ['light', 'colmo', 'dark']
    if (!themes) themes = {}

    this.close = () => { }
    this.commit = (fn, value) => {
      if (!fn) return
      if (typeof fn !== 'string') return
      let USE_WEEX_THEME_CHANNEL = true
      if (fn.includes('_WEEX_THEME_CHANNEL_')) {
        USE_WEEX_THEME_CHANNEL = false
        fn = fn.replace('_WEEX_THEME_CHANNEL_', '')
      }
      let rootState = JSON.parse(JSON.stringify(this.state))
      if (fn === 'setTheme') {
        rootState.value = value.value
        rootState.rootValue = value.root || null
        // 发起广播，同步给其他页面的 state
        USE_WEEX_THEME_CHANNEL &&
          WEEX_THEME_CHANNEL &&
          WEEX_THEME_CHANNEL.postMessage({
            action: 'commit',
            id: this._id,
            data: { fn: 'setTheme', value }
          })
      } else if (fn === 'setTheme_c') {
        rootState._value = value.value
        rootState._rootValue = value.root || null
      }
      this.state = JSON.parse(JSON.stringify(rootState))
    }

    // 设置主题
    // 在插件包全局设置主题 g: true
    // 在插件包当前页面设置主题 g: false
    this.setTheme = (value, options) => {
      return new Promise((resolve) => {
        if(typeof options === 'undefined') options = {}
        if(typeof options === 'boolean') options = { g: options }
        let { g, root } = options
        if (g === undefined) g = true
        if (weex.config.env.platform != 'iOS' && new Date().getTime() - this._create_time < 30) {
          setTimeout(() => this.setTheme(value, options).then(resolve))
        } else {
          if (value === undefined) {
          } else if (value) {
            Object.keys(themes).includes(value) && this.commit(g ? 'setTheme' : 'setTheme_c', root && supportRoot.includes(root) ? { root, value } : { value })
          } else {
            this.commit(g ? 'setTheme' : 'setTheme_c', '')
          }
          resolve()
        }
      })
    }
    // 获取主题
    this.getTheme = () => {
      return this.state._value || this.state.value
    }
    // 获取根主题
    this.getRootTheme = () => {
      let value = this.state._value || this.state.value
      let root = this.state._rootValue || this.state.rootValue
      return supportRoot.includes(root) ? root : supportRoot.includes(value) ? value : ''
    }
    this.getFullTheme = () => {
      let value = this.state._value || this.state.value
      let root = this.state._rootValue || this.state.rootValue
      return root ? root != value ? `${root}.${value}` : value : value
    }

    // 匹配主题配置
    this.watchTheme = (rules) => {
      let result = rules.default || ''
      let _theme
      _theme = this.getRootTheme()
      if (_theme) {
        if (rules) {
          result = rules[_theme] || result
        }
      }
      _theme = this.getTheme()
      if (_theme) {
        if (rules) {
          result = rules[_theme] || result
        }
      }
      return result
    }

    this.state = {
      _value: null, // 当前页面设置主题字段
      value: defaultTheme, // 全局设置主题字段

      // 根主题
      _rootValue: null, // 当前页面设置主题字段
      rootValue: defaultTheme && supportRoot.includes(defaultRoot) ? defaultRoot : null, // 全局设置主题字段
    }
    this._tag = tag
    this._id = id + new Date().getTime()
    this._create_time = new Date().getTime()

    WEEX_THEME_CHANNEL = new BroadcastChannel(`WEEX_THEME_CHANNEL_${id}`)
    // 监听其他页面的 state 变化，调用 commit 更新本页 state
    WEEX_THEME_CHANNEL.onmessage = ({ data: { action, data, id } }) => {
      try {
        if (data) data = typeof data == 'string' ? JSON.parse(data) : data
        // eslint-disable-next-line no-empty
      } catch (e) { }

      if (id !== this._id) {
        if (action == 'commit' && data.fn) {
          // 为方法名添加广播标识，防止重复触发
          this.commit(`${data.fn}_WEEX_THEME_CHANNEL_`, data.value)
        }

        if (action == 'requestState') {
          // 应答同步其他页面同步 state 的请求
          let rootState = JSON.parse(JSON.stringify(this.state))
          delete rootState._value
          delete rootState._rootValue
          WEEX_THEME_CHANNEL &&
            WEEX_THEME_CHANNEL.postMessage({
              action: 'responseState',
              id: this._id,
              data: {
                state: rootState
              }
            })
        }

        if (action == 'responseState' && data.state && UseResponseState) {
          // 处理同步其他页面同步 state 的应答
          UseResponseState = false
          this.state = JSON.parse(JSON.stringify(data.state))
        }
      }
    }

    // 初次构建请求同步其他页面 state
    this.requestSyncState = () => {
      this.requestSyncState = undefined

      WEEX_THEME_CHANNEL &&
        WEEX_THEME_CHANNEL.postMessage({
          action: 'requestState',
          id: this._id
        })
      setTimeout(() => {
        // 关闭引用其他页面的 state，降低性能消耗
        UseResponseState = false
      })
    }
  }
}

export function createWeexTheme(options) {
  if (!weexTheme) {
    weexTheme = new WeexTheme(options)
    if (waitCreateWeexThemeSetThemeArgumentList) {
      waitCreateWeexThemeSetThemeArgumentList.forEach(argument => {
        weexTheme.setTheme(...argument)
      })
      waitCreateWeexThemeSetThemeArgumentList = undefined
    }
    weexTheme.requestSyncState()
  }
  return {
    install: function (Vue, options) {
      Vue.mixin({
        data: () => ({
          __weexTheme: useWeexTheme()
        }),
        methods: {
          $weexThemeClass(staticClass, classBinding) {
            let result = []
            let weexthemeValue = this.$theme.getTheme() // 优先取当前页面设置主题字段
            let weexthemeRootValue = this.$theme.getRootTheme() // 优先取当前页面设置主题字段
            let weexThemeTag = this.$theme._tag
            if (weexthemeValue) {
              if (staticClass) {
                if (typeof staticClass === 'string') {
                  staticClass.split(' ').forEach(selector => {
                    selector && weexthemeRootValue && result.push(`${selector}${weexThemeTag}${weexthemeRootValue}`)
                    selector && result.push(`${selector}${weexThemeTag}${weexthemeValue}`)
                  })
                } else if (Array.isArray(staticClass)) {
                  staticClass.forEach(selector => {
                    selector && weexthemeRootValue && result.push(`${selector}${weexThemeTag}${weexthemeRootValue}`)
                    selector && result.push(`${selector}${weexThemeTag}${weexthemeValue}`)
                  })
                }
              }

              if (classBinding) {
                classBinding.forEach(selector => {
                  selector && result.push(`${selector}${weexThemeTag}${weexthemeValue}`)
                  if (selector) {
                    if (Array.isArray(selector)) {
                      selector.forEach(selector => {
                        selector && weexthemeRootValue && result.push(`${selector}${weexThemeTag}${weexthemeRootValue}`)
                        selector && result.push(`${selector}${weexThemeTag}${weexthemeValue}`)
                      })
                    } else {
                      weexthemeRootValue && result.push(`${selector}${weexThemeTag}${weexthemeRootValue}`)
                      result.push(`${selector}${weexThemeTag}${weexthemeValue}`)
                    }
                  }
                })
              }
            }
            return result
          }
        }
      })

      Vue.prototype.$theme = useWeexTheme()
    }
  }
}

export function useWeexTheme() {
  return weexTheme || {
    setTheme (...argument) {
      waitCreateWeexThemeSetThemeArgumentList.push(argument)
    }
  }
}

export default createWeexTheme




//////////////////
// WEBPACK FOOTER
// ./~/@dolphinweex/weex-theme/index.js
// module id = 127
// module chunks = 0 1